var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 19.9275L9.03409 19.4308C8.89749 20.3835 9.56526 21.2748 10.518 21.4114C11.4708 21.548 12.3621 20.8803 12.4987 19.9275ZM3.21946 16.8292L3.09528 17.6954L18.6858 19.9307L18.81 19.0645L17.3261 17.0839L18.0712 11.887C18.4562 9.20197 17.0592 6.61501 14.5725 5.46294L14.6098 5.20309C14.7464 4.25034 14.0786 3.35904 13.1259 3.22244C12.1731 3.08584 11.2818 3.7536 11.1452 4.70636L11.1079 4.9662C8.39776 5.37318 6.33018 7.4634 5.94521 10.1484L5.20011 15.3453L3.21946 16.8292ZM7.67749 10.3968C8.02521 7.97161 10.2039 6.3393 12.6291 6.68701C15.0543 7.03473 16.6866 9.21344 16.3389 11.6386L15.4696 17.7016L6.80821 16.4598L7.67749 10.3968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5bda2b4658e7fab81ea73987de81c715.svg";
export { ForwardRef as ReactComponent };